import React, { useEffect, useState, useRef, useCallback } from "react";
import axios from "axios";

import { useParams, Link } from "react-router-dom";
import config from "../../../config/config";
import Loader from "../../../components/Loader/Loader";
import Sidebar from "../../Dashboard/Sidebar/Sidebar";
import { AgGridReact } from "ag-grid-react";
import jsPDF from "jspdf";
import JsBarcode from "jsbarcode";
import html2canvas from "html2canvas";
import { toastError, toastSuccess } from "../../../common/Toast";
import { DATA_EXPORT, ERROR_MESSAGE } from "../../../common/Constant";
import { Calendar } from "../../../common/imagePath";
import ReactDatetime from "react-datetime";
import moment from "moment";
import ReportDate from "../../../components/Reports/ReportDate";
import * as XLSX from "xlsx";
import Select from "react-select";
const currentDate = new Date();
const monthNames = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December",
];
const month = monthNames[currentDate.getMonth()]; // add 1 to get month value from 1 to 12
const hours = currentDate.getUTCHours();
const minutes = currentDate.getUTCMinutes();

const SalesbyCustomerSummaryReport = (props) => {
  const token = localStorage.getItem("Token");
  const [formValues, setFormValues] = useState([]);
  const [responseData, setResponseData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [totalSum, setTotalSum] = useState(0);
  const [columnby, setcolumnby] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [startdate, setStartDate] = useState(moment().format("YYYY-MM-DD"));
  const [enddate, setEndDate] = useState(moment().format("YYYY-MM-DD"));
  const [selectedDate, setSelectedDate] = useState([]);
  const [selectReport, setSelectReport] = useState("");
  const [mappeddata, setMappedData] = useState([]);

  const ITEMS_PER_PAGE = 10;

  const barcodeRefs = useRef([]);
  let index = 0;
  const [data, setData] = useState({
    inputValue: "",
    width: 1,
    height: 20,
    fontSize: 15,
    zeroFill: 10,
  });

  //Function to generate barcode
  const generateBarcodes = () => {
    barcodeRefs.current.forEach((barcodeRef, index) => {
      console.log("barcodeRefs", barcodeRefs);
      var g = document.getElementsByTagName(barcodeRef);
      const barcodeValue = paramObject.id;
      console.log("barcodeValue", barcodeValue);
      const paddedBarcodeValue = barcodeValue.padStart(data.zeroFill, "0");
      JsBarcode(barcodeRef, paddedBarcodeValue, {
        width: data.width,
        height: data.height,
        fontSize: data.fontSize,
        displayValue: true,
        fontoptions: "bold",
        textAlign: "center",
        font: "monospace",
        textPosition: "bottom",
        textMargin: 2,
        margin: 10,
        marginTop: undefined,
        marginBottom: undefined,
        marginLeft: undefined,
        marginRight: undefined,
        format: "CODE128",
        valid: () => true,
        background: "#ffffff",
        lineColor: "#000000",
        padding: data.zeroFill,
      });
    });
  };

  const columnDefs = [
    { field: "Customername", width: 1030 },
    { field: "TotalAmount", aggFunc: "sum" },
  ];

  //Function for downloading pdf of barcodesheet

  //Function for print

  const handleDropdownChange = (event) => {
    setSelectReport(event?.value);
  };

  const totalFooterRow = {
    Customername: "Total",
    TotalAmount: `$${Number(totalSum).toFixed(2)}`,
  };

  const augmentedData = [...responseData, totalFooterRow];

  const paramObject = useParams();
  const apicall = () => {
    axios
      .get(
        `${config.reportsBaseUrl}/reports/salesbycustomer?startdate=${startdate}&enddate=${enddate}&columnby=${columnby}`,
        {
          headers: {
            "Content-Type": "application/json;charset=UTF-8",
            "Access-Control-Allow-Origin": "*",
            Authorization: token,
          },
        }
      )
      .then((res) => {
        console.log("res======>", res);
        console.log(res.data.ResponseData);
        if (res.data.ResponseCode === "SUCCESS") {
          setResponseData(res.data.ResponseData);
          console.log("11", responseData);
          //   barcodeRefs.current = responseData;
        }
        setLoading(false);
      })
      .catch((err) => {
        console.log(err);
        setLoading(false);
      });
  };

  useEffect(() => {
    generateBarcodes();
    console.log("barcodeRefs", barcodeRefs);
    // setLoading(true);

    // axios
    //   .get(
    //     `${
    //       config.reportsBaseUrl
    //     }/reports/salesbycustomer?startdate=${""}&enddate=${""}&columnby=${""}`,
    //     {
    //       headers: {
    //         "Content-Type": "application/json;charset=UTF-8",
    //         "Access-Control-Allow-Origin": "*",
    //         Authorization: token,
    //       },
    //     }
    //   )
    //   .then((res) => {
    //     console.log("res======>", res);
    //     console.log(res.data.ResponseData);
    //     if (res.data.ResponseCode === "SUCCESS") {
    //       setResponseData(res.data.ResponseData);
    //       console.log("11", responseData);
    //       //   barcodeRefs.current = responseData;
    //     }
    //     setLoading(false);
    //   })
    //   .catch((err) => {
    //     console.log(err);
    //     setLoading(false);
    //   });

    axios
      .get(`${config.reportsBaseUrl}/reports/reportperioddropdown`, {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          Authorization: token,
        },
      })
      .then((res) => {
        console.log("setSelectedDate======>", res);
        setSelectedDate(res.data.ResponseData);
        // setLoading(false);
        return res;
      });

    axios
      .get(`${config.reportsBaseUrl}/reports/reportsbindingdropdown`, {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          Authorization: token,
        },
      })
      .then((res) => {
        console.log("column======>", res);
        setcolumnby(res.data.ResponseData);
        // setLoading(false);
        return res;
      });
  }, []);

  // to calculate the total
  const calculateTotalSum = () => {
    const sum = responseData.reduce((total, report) => {
      const reportTotal = Number(report.TotalAmount);

      if (typeof reportTotal === "number" && !isNaN(reportTotal)) {
        return total + reportTotal;
      } else {
        return total;
      }
    }, 0);

    setTotalSum(sum);
  };

  useEffect(() => {
    calculateTotalSum();
  }, [responseData]);

  const callback = (payload, enddate2) => {
    console.log("stardate =>", payload);
    setStartDate(payload);
    setEndDate(enddate2);

    console.log("enddate =>", enddate2);
  };

  // handle print-
  const handlePrintPDF = () => {
    setLoading(true);
    var doc = new jsPDF("p", "pt", "a4");

    // Add the header
    let headerElement = document.querySelector("#header");
    let clonedHeader = headerElement.cloneNode(true);
    clonedHeader.style.fontSize = `10px`;
    clonedHeader.style.width = "560px";
    clonedHeader.style.margin = "1rem";

    let content = "";
    let startIndex = 1;
    let endIndex = 23;

    for (var i = 1; i <= Math.ceil(responseData.length / 23); i++) {
      if (i == 1) {
        clonedHeader.style.marginTop = "2rem";
      }
      if (i > 1) {
        clonedHeader.style.marginTop = "2.5rem";
      }
      // Printing header-
      content += " " + clonedHeader.outerHTML;

      // Printing table body-
      content +=
        '<table style="font-size: 8px; margin-left: 1rem; margin-top: 2rem; width: 560px; border: 1px solid #f5f5f5">';
      content +=
        "<thead><tr style='margin-bottom: 5px'>" +
        '<th style="padding: 8px;">Customer Name</th>' +
        '<th style="padding: 8px; text-align: right">Total Amount</th>';
      content += "</tr></thead>";
      content += "<tbody>";

      // Loop for printing items based on endIndex-
      for (let index = startIndex; index <= endIndex; index++) {
        if (index >= startIndex && index <= responseData.length) {
          content +=
            "<tr>" +
            '<td style="font-size: 8px; padding: 8px;">' +
            responseData[index - 1].Customername +
            "</td>" +
            '<td style="font-size: 8px; padding: 8px; text-align: right">' +
            Number(responseData[index - 1].TotalAmount).toFixed(2) +
            "</td>";

          content += "</tr>";
        }

        if (index % 23 == 0) {
          startIndex = startIndex + 23;
          endIndex = endIndex + 23;
          break;
        }
      }

      content += "</tbody>";
      content += "</table>";
    }

    // Printing page-
    doc.html(content, {
      callback: function (pdf) {
        setLoading(false);
        pdf.output("dataurlnewwindow");
      },
    });
  };

  // handle download-
  const handleDownloadPDF = () => {
    setLoading(true);
    var doc = new jsPDF("p", "pt", "a4");

    // Add the header
    let headerElement = document.querySelector("#header");
    let clonedHeader = headerElement.cloneNode(true);
    clonedHeader.style.fontSize = `10px`;
    clonedHeader.style.width = "560px";
    clonedHeader.style.margin = "1rem";

    let content = "";
    let startIndex = 1;
    let endIndex = 23;

    for (var i = 1; i <= Math.ceil(responseData.length / 23); i++) {
      if (i == 1) {
        clonedHeader.style.marginTop = "2rem";
      }
      if (i > 1) {
        clonedHeader.style.marginTop = "2.5rem";
      }
      // Printing header-
      content += " " + clonedHeader.outerHTML;

      // Printing table body-
      content +=
        '<table style="font-size: 8px; margin-left: 1rem; margin-top: 2rem; width: 560px; border: 1px solid #f5f5f5">';
      content +=
        "<thead><tr style='margin-bottom: 5px'>" +
        '<th style="padding: 8px;">Customer Name</th>' +
        '<th style="padding: 8px; text-align: right">Total Amount</th>';
      content += "</tr></thead>";
      content += "<tbody>";

      // Loop for printing items based on endIndex-
      for (let index = startIndex; index <= endIndex; index++) {
        if (index >= startIndex && index <= responseData.length) {
          content +=
            "<tr>" +
            '<td style="font-size: 8px; padding: 8px;">' +
            responseData[index - 1].Customername +
            "</td>" +
            '<td style="font-size: 8px; padding: 8px; text-align: right">' +
            Number(responseData[index - 1].TotalAmount).toFixed(2) +
            "</td>";

          content += "</tr>";
        }

        if (index % 23 == 0) {
          startIndex = startIndex + 23;
          endIndex = endIndex + 23;
          break;
        }
      }

      content += "</tbody>";
      content += "</table>";
    }

    // Printing page-
    doc.html(content, {
      callback: function (pdf) {
        setLoading(false);
        pdf.save("pdf.pdf");
      },
    });
  };

  const onGridReady = useCallback((params) => {
    setLoading(true);

    axios
      .get(
        `${
          config.reportsBaseUrl
        }/reports/salesbycustomer?startdate=${""}&enddate=${""}&columnby=${""}`,
        {
          headers: {
            "Content-Type": "application/json;charset=UTF-8",
            "Access-Control-Allow-Origin": "*",
            Authorization: token,
          },
        }
      )
      .then((res) => {
        console.log("res======>", res);
        console.log(res.data.ResponseData);
        if (res.data.ResponseCode === "SUCCESS") {
          setResponseData(res.data.ResponseData);
          const mappeddata = res.data.ResponseData?.map((item, index) => {
            return {
              customername: item.Customername,
              amount: item.TotalAmount,
            };
          });
          setMappedData(mappeddata);
          //   barcodeRefs.current = responseData;
        }
        setLoading(false);
      })
      .catch((err) => {
        console.log(err);
        setLoading(false);
      });
  }, []);

  // useEffect(() => {
  //   onGridReady();
  // }, [onGridReady]);

  const onBtExport = () => {
    const workbook = XLSX.utils.book_new();

    // Convert the data to a worksheet
    const worksheet = XLSX.utils.json_to_sheet(mappeddata);

    // Add the worksheet to the workbook
    XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");

    // Save the workbook as an Excel file
    XLSX.writeFile(workbook, `SalesbyCustomerSummary_.xlsx`);
  };

  let reportdropdown = [];
  const data2 = selectedDate.map(
    (u, i) => (reportdropdown[i] = { label: u.Name, value: u.ID })
  );

  const defaultColDef = {
    sortable: true,
  };

  return (
    <>
      <Loader loading={loading} />
      <Sidebar />
      <div className="page-wrapper">
        <div className="content">
          <div className="page-header">
            <div className="page-title">
              <h3>Sales By Customer Summary</h3>
              <ul className="breadcrumb">
                <li className="breadcrumb-item">
                  <Link to="/dashboard">Dashboard</Link>
                </li>
                <li className="breadcrumb-item">
                  <Link to="/report">Report</Link>
                </li>
                <li className="breadcrumb-item active">
                  Sales By Customer Summary
                </li>
              </ul>
            </div>
          </div>

          <div className="row">
            <div className="col-sm-3 ">
              <div className="form-group row">
                <label className="col-form-label col-md-5 form-label">
                  Report period
                </label>
                <div className="col-md-7">
                  <Select
                    options={reportdropdown}
                    defaultValue={selectReport}
                    backspaceRemovesValue={false}
                    controlShouldRenderValue={true}
                    hideSelectedOptions={true}
                    isClearable={true}
                    name="Reportperiod"
                    id="Reportperiod"
                    //  value={selectedDate}
                    onChange={(event) => {
                      handleDropdownChange(event);
                    }}
                  ></Select>
                </div>
              </div>
            </div>
            <div className="col-sm-6 ">
              <div className="form-group row">
                <ReportDate
                  callback={callback}
                  selectReport={selectReport}
                  showhidecomponent={
                    selectReport == 2 ||
                    selectReport == 3 ||
                    selectReport == 4 ||
                    selectReport == 5 ||
                    selectReport == 6 ||
                    selectReport == 7 ||
                    selectReport == 8 ||
                    selectReport == 9 ||
                    selectReport == 10 ||
                    selectReport == 11 ||
                    selectReport == 12 ||
                    selectReport == 13 ||
                    selectReport == 14 ||
                    selectReport == 15 ||
                    selectReport == 16 ||
                    selectReport == 17 ||
                    selectReport == 18 ||
                    selectReport == 19 ||
                    selectReport == 20 ||
                    selectReport == 21 ||
                    selectReport == 22 ||
                    selectReport == 23 ||
                    selectReport == 24 ||
                    selectReport == 25 ||
                    selectReport == 26 ||
                    selectReport == 27 ||
                    selectReport == 28 ||
                    selectReport == 29 ||
                    selectReport == 30 ||
                    selectReport == 31
                      ? true
                      : false
                  }
                />
              </div>
            </div>

            <div className="col-sm-3">
              <button
                type="submit"
                className="btn btn-primary pull-right "
                style={{ marginLeft: "auto" }}
                onClick={apicall}
              >
                Generate Report
              </button>
            </div>
          </div>

          {/* <div className="row">
            <div className="col-sm-6 mt-2">
              <div className="form-group row">
                <label className="col-form-label col-md-3 form-label">
                  Group By
                </label>
                <div className="col-md-9">
                  <select
                    as="select"
                    className="form-control w-75"
                    name="groupby"
                    id="groupby"
                  >
                    {columnby.map((u) => (
                      <option value={u.Name}> {u.Name} </option>
                    ))}
                  </select>
                </div>
              </div>
            </div>
            <div className="col-sm-6 mt-2">
              <div className="form-group row">
                <button
                  type="submit"
                  className="btn btn-primary pull-right mb-3 w-50 mt-0"
                  style={{ marginLeft: "auto" }}
                  onClick={apicall}
                >
                  Generate Report
                </button>
              </div>
            </div>
          </div> */}

          {/* Receipt */}

          <div className="card mt-5" id="print">
            <div className="card-body">
              <div className="container">
                <div className="col-md-12 text-center" id="header">
                  <h2>SonarPos</h2>
                  <p className="fw-bold">Sales By Customer Summary</p>
                  <div className="row">
                    <p>
                      Date: {startdate} - {enddate}
                    </p>
                  </div>
                </div>
              </div>
              <hr />
              <div className="table-responsive">
                <div className="button">
                  <button
                    onClick={onBtExport}
                    className="btn btn-sm btn-outline-dark  m-1"
                    // style={{ marginBottom: '5px',marginLeft: "5px", fontWeight: 'bold' }}
                  >
                    <i class="fas fa-file-excel mr-2"></i>
                    Export to Excel
                  </button>
                  <button
                    onClick={handleDownloadPDF}
                    className="btn btn-sm btn-outline-dark  m-1"
                    // style={{ marginBottom: '5px',marginLeft: "5px", fontWeight: 'bold' }}
                  >
                    <i class="fas fa-file-export mr-2"></i>
                    Export to Pdf
                  </button>
                  <button
                    className="btn btn-sm btn-outline-dark  m-1"
                    onClick={handlePrintPDF}
                  >
                    <i class="fas fa-print mr-2"></i>
                    Print
                  </button>
                </div>
                <div
                  className="ag-theme-alpine"
                  id="header"
                  style={{ height: "100vh", width: "100%" }}
                >
                  <AgGridReact
                    rowData={augmentedData}
                    columnDefs={columnDefs}
                    defaultColDef={defaultColDef}
                    // autoGroupColumnDef={autoGroupColumnDef}
                    autoGroupColumnDef={{
                      headerName: "CustomerName",
                      minWidth: 1030,
                    }}
                    onGridReady={onGridReady}
                    groupIncludeFooter={true}
                    // groupIncludeTotalFooter={true}
                    animateRows={true}
                  ></AgGridReact>
                </div>

                {/* <div style={{ textAlign: "right" }} className="mx-5 mt-5">
                  <h6>Total Amount: ${Number(totalSum).toFixed(2)}</h6>
                  <hr
                    style={{
                      display: "inline-block",
                      borderBottom: "3px solid black",
                      width: "30%",
                    }}
                  />
                </div> */}
                <hr />
              </div>
              <div className="row">
                <div className="col-md-12 text-center">
                  <h6>
                    {" "}
                    {currentDate.toLocaleString()} &nbsp;GMT Time: {hours}:
                    {minutes}
                  </h6>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div style={{ display: "none" }}>
        {responseData.map((item) => (
          <>
            {/* <button onClick={console.log("item", item)}>click me</button> */}
            <div key={item.SaleId}>
              <canvas
                data-name={item.SaleId}
                ref={(el) => (barcodeRefs.current[item.SaleId] = el)}
                id={`barcode-${item.SaleId}`}
              />
            </div>
          </>
        ))}
      </div>
    </>
  );
};

export default SalesbyCustomerSummaryReport;
